export function formatText(text) {
  return text
    .split("\n\n") // split paragraphs
    .map(
      (para) => `<p style="margin-bottom: 1em;">
  ${para
    .replace(/\n/g, "<br/>") // convert newlines
    .replace(/(\d+)\./g, " <b>$1.</b>") // add line break before numbered points
    .trim()}
</p>`
      // (para) => `<p style="margin-bottom: 1em;">${para.replace(/\n/g, "<br/>").trim()}</p>`
    )
    .join("");
}
export function formatText1(text) {
  if (!text) return "";
  
  if (typeof text !== "string") text = String(text);
  // Convert special characters to HTML-safe format
  let formatted = text
    .replace(/\n/g, "<br/>") // Convert line breaks to <br/>
    .replace(/  /g, "&nbsp;&nbsp;"); // Preserve double spaces

  return formatted;
}

export function formatDuration(seconds) {
  const minute = 60;
  const hour = 60 * minute;
  const day = 24 * hour;
  const month = 30 * day; // approximate month as 30 days

  if (seconds < minute) {
    return `${seconds} sec`;
  } else if (seconds < hour) {
    const m = Math.floor(seconds / minute);
    const s = seconds % minute;
    return s ? `${m} min ${s} sec` : `${m} min`;
  } else if (seconds < day) {
    const h = Math.floor(seconds / hour);
    const m = Math.floor((seconds % hour) / minute);
    return m ? `${h} hr ${m} min` : `${h} hr`;
  } else if (seconds < month) {
    const d = Math.floor(seconds / day);
    const h = Math.floor((seconds % day) / hour);
    return h ? `${d} day ${h} hr` : `${d} day`;
  } else {
    const mo = Math.floor(seconds / month);
    const d = Math.floor((seconds % month) / day);
    return d ? `${mo} month ${d} day` : `${mo} month`;
  }
}

export function formatDurationNew(seconds) {
  const minute = 60;
  const hour = 60 * minute;
  const day = 24 * hour;
  const month = 30 * day; // approximate month as 30 days

  if (seconds < minute) {
    return `${seconds} SECONDS`;
  } else if (seconds < hour) {
    const m = Math.floor(seconds / minute);
    const s = seconds % minute;
    return s ? `${m} MINUTES ${s} SECONDS` : `${m} MINUTES`;
  } else if (seconds < day) {
    const h = Math.floor(seconds / hour);
    const m = Math.floor((seconds % hour) / minute);
    return m ? `${h} HOURS ${m} MINUTES` : `${h} HOURS`;
  } else if (seconds < month) {
    const d = Math.floor(seconds / day);
    const h = Math.floor((seconds % day) / hour);
    return h ? `${d} DAYS ${h} HOURS` : `${d} DAYS`;
  } else {
    const mo = Math.floor(seconds / month);
    const d = Math.floor((seconds % month) / day);
    return d ? `${mo} MONTHS ${d} DAYS` : `${mo} MONTHS`;
  }
}
